import { Location, Mutation } from 'graphql/generated/graphqlTypes';
import { generateMockLocation } from 'mocks/graphqlMocks/location';

export function mockedAddLocationWithDoorsData(addLocation: Location): Pick<Mutation, 'addLocation'> {
  return {
    addLocation
  };
}

export const mockedAddLocationWithDoorsDataForMutation = mockedAddLocationWithDoorsData(
  generateMockLocation({ id: 'mockedAddedLocationId', name: 'mockedLocationName' })
);

export const mockedAddDeviceGroupDataForMutation = mockedAddLocationWithDoorsData(
  generateMockLocation({ id: 'mockedAddedLocationId', name: 'New group' })
);
